import { c as _c } from "react/compiler-runtime";
import { postHostedUserVaultDecrypt } from '@onefootprint/fetch-hosted';
import type { DataIdentifier } from '@onefootprint/request-types';
import { useMutation } from '@tanstack/react-query';
import { AUTH_HEADER } from '../types';
type DecryptFields = DataIdentifier[];
type DecryptUserRequest = {
  authToken: string;
  fields: DecryptFields;
};
type DecryptUserResponse = Record<string, string | undefined>;
const useDecryptUser = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export default useDecryptUser;
async function _temp(t0) {
  const {
    authToken,
    fields
  } = t0;
  const {
    data
  } = await postHostedUserVaultDecrypt({
    body: {
      fields
    },
    headers: {
      [AUTH_HEADER]: authToken
    }
  });
  return data as DecryptUserResponse;
}